import { COLOR_GREEN_700 } from '@alltrails/denali/tokens';
import { createCircleMarker } from './svgMarkerComponents';

const trailClusterHoveredSvg = createCircleMarker({ imageName: 'trail-cluster-hovered', innerDiameter: 24, innerFill: COLOR_GREEN_700 });

export default trailClusterHoveredSvg;
